import { genUniqueId } from "../utils";

// CREATE
export const CREATE_HUMAN_COMMENT = "CREATE_HUMAN_COMMENT";

export function createHumanComment(humanId, text) {
  return {
    type: CREATE_HUMAN_COMMENT,
    id: genUniqueId(),
    humanId,
    text,
  };
}

// UPDATE
export const UPDATE_HUMAN_COMMENT = "UPDATE_HUMAN_COMMENT";

export function updateHumanComment(humanCommentId, obj) {
  return {
    type: UPDATE_HUMAN_COMMENT,
    id: humanCommentId,
    obj,
  };
}

// REVERT
export const REVERT_HUMAN_COMMENT = "REVERT_HUMAN_COMMENT";

export function revertHumanComment(humanCommentId) {
  return {
    type: REVERT_HUMAN_COMMENT,
    id: humanCommentId,
  };
}

// DELETE
export const DELETE_HUMAN_COMMENT = "DELETE_HUMAN_COMMENT";

export function deleteHumanComment(id) {
  return {
    type: DELETE_HUMAN_COMMENT,
    id,
  };
}
